const CONTENT_HELPER_TEXT = {
  adminNotes: `Content writer can add notes about the content for internal 
  reference only.`,
  basePointValue: `The number of points a user earns for successfully
  'completing' the content`,
  contentTypeEdit: "Use content detail view to edit this",
  contentType: "Select the type of content",
  coverImage: `A summary image for the content. Accepted file 
  types: .jpg, .jpeg, .png, .gif, .bmp, .svg`,
  descriptionEn: "Content Description (English)",
  descriptionEs: "Content Description (Spanish)",
  difficulty: "Select the level of content difficulty",
  featureOrder: `The order in which content modules are 
  presented to PayPerks users.`,
  isPublished: "Only content that is published will be visible to users",
  nameEn: "Content Name (English)",
  nameEs: "Content Name (Spanish)",
  sites: "Sites and card programs of this content",
  topic: "Topic that this content belongs to",
};

const CONTENT_ITEM_HELPER_TEXT = {
  content: "Content module this item belongs to",
  order: `On a content detail page, Content Items are displayed in 
  this order (ascending)`,
  points: "Points for correct answer",
  type: "Select content item type",
};

const CONTENT_TAG_HELPER_TEXT = {
  content: "Content module this tag applies to",
  key: "e.g. 'card_variant' or 'content_group'",
  value: "e.g. '1' or 'identity_theft'",
};

const TOPIC_HELPER_TEXT = {
  coverImage: `A summary image for the topic. Accepted file types: 
  .jpg, .jpeg, .png, .gif, .bmp, .svg`,
  descriptionEn: "Topic Description (English)",
  descriptionEs: "Topic Description (Spanish)",
  nameEn: "Topic Name (English)",
  nameEs: "Topic Name (Spanish)",
};

export {
  CONTENT_HELPER_TEXT,
  CONTENT_ITEM_HELPER_TEXT,
  CONTENT_TAG_HELPER_TEXT,
  TOPIC_HELPER_TEXT,
};
